module.exports = __webpack_public_path__ + "static/img/scramble_logo.0baeaf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2021/program_logo/scramble_logo.png
// module id = BxJt
// module chunks = 0